import { FileType } from 'entities/Files/types';

export const getModelKey = (
	file: Pick<FileType, 'category' | 'customModelId' | 'generativeModelId'>,
): string => {
	if (file.customModelId) return file.customModelId;
	if (file.generativeModelId) return file.generativeModelId;
	return file.category;
};
